import { Box } from '@mui/material'

export default function DimensionHeroImage({ src, alt }) {
  if (!src) return null

  return (
    <Box
      sx={{
        width: '100%',
        height: { xs: 240, sm: 360, md: 500, lg: 740 },
        borderRadius: '20px',
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    </Box>
  )
}
